import { useModeContext } from 'canoe';
import React, { useCallback } from 'react';

import {
  PositionSelector,
  PositionSelectorButton,
  PositionSelectorWrapper,
  ValueGroup,
} from '@candu-ai/craft/ui';
import { CRAFT_ROOT_ID } from 'craft/constants';
import { Section } from 'craft/containers/Toolbox/components';
import { useResponsiveCss } from 'craft/hooks';
import { useModalPosition } from 'craft/resolvers/Modal/useModalPosition';
import { createToggle } from 'craft/utils';

import { OverlayZindex } from './OverlayZindex';

const Selector = () => {
  const { mode } = useModeContext();
  const { responsiveCss, setResponsiveCss } = useResponsiveCss([CRAFT_ROOT_ID]);
  const { positionName, positionProps, setPosition: setPositionValues } = useModalPosition();

  const toggleCssValues = createToggle(responsiveCss ?? {}, setResponsiveCss);
  const togglePropsValues = createToggle(positionProps, setPositionValues);

  const setPosition = useCallback(
    (newPosition: string) => {
      const parsedValues = newPosition.split('-');
      const verticalPosition = parsedValues[0];
      const horizontalPosition = parsedValues[1];

      toggleCssValues({
        marginLeft: horizontalPosition === 'left' ? '16px' : '0px',
        marginTop: verticalPosition === 'top' ? '16px' : '0px',
        marginRight: horizontalPosition === 'right' ? '16px' : '0px',
        marginBottom: verticalPosition === 'bottom' ? '16px' : '0px',
      });
      togglePropsValues({ verticalPosition, horizontalPosition });
    },
    [toggleCssValues, togglePropsValues],
  );

  return (
    <PositionSelectorWrapper mode={mode}>
      <PositionSelectorButton
        isSelected={positionName === 'top-left'}
        onClick={() => setPosition('top-left')}
        mode={mode}
      />
      <PositionSelectorButton
        isSelected={positionName === 'top-center'}
        onClick={() => setPosition('top-center')}
        mode={mode}
      />
      <PositionSelectorButton
        isSelected={positionName === 'top-right'}
        onClick={() => setPosition('top-right')}
        mode={mode}
      />
      <PositionSelectorButton
        isSelected={positionName === 'center-left'}
        onClick={() => setPosition('center-left')}
        mode={mode}
      />
      <PositionSelectorButton
        isSelected={positionName === 'center-center'}
        onClick={() => setPosition('center-center')}
        mode={mode}
      />
      <PositionSelectorButton
        isSelected={positionName === 'center-right'}
        onClick={() => setPosition('center-right')}
        mode={mode}
      />
      <PositionSelectorButton
        isSelected={positionName === 'bottom-left'}
        onClick={() => setPosition('bottom-left')}
        mode={mode}
      />
      <PositionSelectorButton
        isSelected={positionName === 'bottom-center'}
        onClick={() => setPosition('bottom-center')}
        mode={mode}
      />
      <PositionSelectorButton
        isSelected={positionName === 'bottom-right'}
        onClick={() => setPosition('bottom-right')}
        mode={mode}
      />
    </PositionSelectorWrapper>
  );
};

interface Props {
  nodeIds: string[];
}

export const OverlayPosition = ({ nodeIds }: Props) => {
  return (
    <Section name="Position">
      <ValueGroup>
        <PositionSelector selectorComponent={<Selector />} label="Overlay position" />
      </ValueGroup>
      <ValueGroup>
        <OverlayZindex nodeIds={nodeIds} />
      </ValueGroup>
    </Section>
  );
};
